<template>
  <div class="gos" style="background:black">
    <div class="header" @click="reload()">
      <img src="https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/userContent%2Fgirlsofslink%2Fprofile?alt=media&token=9a499c0d-579b-401b-977e-fcca2605b1d2" style="max-height: 64px;">
      <div v-if="path == 'gos'" class="gosHeader">Girls of Slink</div>
      <div v-else class="bosHeader">Boys of Slink</div>
    </div>
    <div class="content">
      <div v-for="(user, index) in gosList" :key="index" class="section user-div" :data-user-id="user.id" :data-user-index="index">
        
      <div class="displayImageContainer" style="" v-bind:class="{'fcProfile': user.f}">
        <img class="displayImage" v-if="user.id" :src="getImage(user[path], user)" loading="lazy">
        <div class="actionBar">
          <div>
            <div class="name">{{ user.name }}</div>
            <div class="url">{{ user.bio }}</div>
          </div>
          <div style="display:flex; position:relative; flex-flow: column;align-items: center;">
            <div style="position:relative" @click="openSlink(user.id, user.url)">
              <md-avatar class="md-large" style="height:72px; width:72px;position:relative" >
                <img :src="user.picture" alt="Avatar" loading="lazy">
              </md-avatar>
              <md-button class="md-icon-button md-dense md-raised" style="position: absolute; bottom: -10px; right: 20px; color:black; background: white; margin: unset;">
                <md-icon v-bind:class="{'fancentro': user.f}">add</md-icon>
              </md-button>
            </div>
            <md-button v-if="canShare" class="md-icon-button md-dense"  @click="webShare(user)" style="margin-top:20px">
              <md-icon>share</md-icon>
            </md-button>
            <md-button v-else class="md-icon-button md-dense" style="margin-top:20px">
              <md-icon>link</md-icon>
            </md-button>
          </div>
        </div>




      </div>
        <div class="ad">
          <div v-for="(ad, index) in getAd()">
            <iframe v-if="ad.iframe" :src="ad.source" style="aspect-ratio:300/100; width: 100vw; border: 0px solid; vertical-align: bottom;" scrolling="no"></iframe>
            <a  v-else :href="ad.target">
              <img style="height:100%; width:100%; aspect-ratio:300/100" :src="ad.image" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fb } from './firebaseconfig';
import { analytics } from "./firebaseconfig";

const db = fb.database();

const remoteConfig = fb.remoteConfig();
const isLocalhost = window.location.hostname === 'localhost';
remoteConfig.settings.minimumFetchIntervalMillis = isLocalhost ? 3000 : 86400000;
// remoteConfig.settings.minimumFetchIntervalMillis = 3000;

remoteConfig.ensureInitialized().then(() => {
  // Remote config initialized
}).catch((err) => {
  console.error('Firebase Remote Config failed to initialize', err);
});

export default {
  metaInfo: {
    // title: 'Girls of Slink', // set a title if needed
  },
  data() {
    return {
      path: this.$route.path.includes("/girlsofslink") ? "gos" : "bos",
      gos: [],
      gosList: [],
      loadedProfiles: [],
      cumulativeWeight: 0,
      lastPos: null,
      ads: null,
    };
  },
  async beforeCreate() {
    // console.log(this.$route)/s
    try {
      await remoteConfig.fetchAndActivate();
      const ads = remoteConfig.getValue('gosAds')._value;
      this.ads = JSON.parse(ads);
    } catch (error) {
      console.error('Error fetching and activating remote config:', error);
    }
  },
  async mounted() {
    await this.fetchInitialUserData();
    this.initializeIntersectionObserver();
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  computed: {
    canShare() {
      return !!navigator.share;
    },
  },
  methods: {
    getAd1() {
      if (this.ads) {
        const randomIndex = Math.floor(Math.random() * this.ads.length);
        return [this.ads[randomIndex]];
      }
      return [];
    },
    getAd() {
  if (this.ads && this.ads.length > 0) {
    // Filter the ads to include those that are enabled and either have showOn as 'all', or matching this.path, or do not have a showOn property
    const filteredAds = this.ads.filter(ad => 
      ad.enabled && (!ad.showOn || ad.showOn === 'all' || ad.showOn === this.path)
    );
    
    if (filteredAds.length > 0) {
      const randomIndex = Math.floor(Math.random() * filteredAds.length);
      return [filteredAds[randomIndex]];
    }
  }
  
  return [];
},

    openSlink(uid, url) {
      // console.log('Opening URL for', uid, url);
      db.ref(`${this.path}/${uid}/clicks`).transaction((currentValue) => {
        return (currentValue || 0) + 1;
      });
      window.open(`https://myslink.app/${url}`);
    },
    getImage(images) {
      if (Array.isArray(images) && images.length > 0) {
          const randomIndex = Math.floor(Math.random() * images.length);
          return images[randomIndex];
      } else {
          return null; // Or return a default image URL
      }
    },
    webShare(user) {
      if (this.canShare) {
        navigator.share({
          title: user.name,
          text: `Check out ${user.name}'s social media and websites on their Slink Digital Business Card`,
          url: `https://MySlink.app/${user.url}`
        }).then(() => {
          console.log('Web share successful');
        }).catch((error) => {
          console.error('Web share failed:', error);
        });
      } else {
        console.log('Web share not supported');
      }
    },
    reload() {
      window.location.reload();
    },
    loadMoreProfiles() {
      const rand = Math.random() * this.cumulativeWeight;
      const selectedUser = this.gos.find(user => user.cumulativeWeight >= rand);
      if (selectedUser) {
        this.gosList.push(selectedUser);
        this.$nextTick(this.updateObservers);
      }
    },
    updateObservers() {
      document.querySelectorAll('.section.user-div:not(.observed)').forEach(userDiv => {
        this.observer.observe(userDiv);
        userDiv.classList.add('observed'); // Mark it as observed
      });
    },async fetchInitialUserData() {
    try {
        const idsSnapshot = await db.ref(`/${this.path}/`).once('value');
        const idsObject = idsSnapshot.val();
        if (!idsObject) return;

        const today = new Date().toISOString().slice(0, 10);
        this.gos = this.calculateUserWeights(idsObject, today);
        this.cumulativeWeight = this.gos.reduce((sum, user) => sum + user.weight, 0);

        this.selectInitialUser();
        this.$nextTick(this.initializeIntersectionObserver);
    } catch (error) {
        console.error('Error fetching initial user data:', error);
    }
},

calculateUserWeights(idsObject, today) {
    let cumulativeWeight = 0;
    return Object.keys(idsObject).map(id => {
        const user = idsObject[id];
        let userWeight = user.weight || 10;
        if (user.f) userWeight *= 2;
        if (user.p) userWeight *= 2;
        if (user.bday && user.bday.slice(5, 10) === today.slice(5, 10)) userWeight *= 25;
        cumulativeWeight += userWeight;
        return {
            id,
            ...user,
            weight: userWeight,
            cumulativeWeight,
            image: this.getImage(user[this.path])
        };
    });
},

selectInitialUser() {
    let selectedUser = null;
    if (this.$route.params.url) {
        const selectedUserId = this.$route.params.url;
        selectedUser = this.gos.find(user => user.id === selectedUserId);
    } else {
        const numberOfUsersToSelect = 5;
        for (let i = 0; i < numberOfUsersToSelect; i++) {
            const rand = Math.random() * this.cumulativeWeight;
            selectedUser = this.gos.find(user => user.cumulativeWeight >= rand);
        }
    }
    if (selectedUser) {
        this.gosList.push(selectedUser);
        // console.log('#', selectedUser);
    }
},
  //   async fetchInitialUserData() {
  //   try {
  //     const idsSnapshot = await db.ref(`/${this.path}/`).once('value');
  //     const idsObject = idsSnapshot.val();
  //     if (!idsObject) return;
  //     const today = new Date().toISOString().slice(0, 10);
  //     let cumulativeWeight = 0;
  //     this.gos = Object.keys(idsObject).map(id => {
  //       const user = idsObject[id];
  //       let userWeight = user.weight || 10;
  //       if (user.f) userWeight *= 2;
  //       if (user.p) userWeight *= 2;
  //       if (user.bday && user.bday.slice(5, 10) === today.slice(5, 10)) userWeight *= 25;
  //       cumulativeWeight += userWeight;
  //       return {
  //         id,
  //         ...user,
  //         weight: userWeight,
  //         cumulativeWeight,
  //         image: this.getImage(user[this.path])
  //       };
  //     });
  //     this.cumulativeWeight = cumulativeWeight;
  //     let selectedUser = null
  //     if (this.$route.params.url) {
  //       const selectedUserId = this.$route.params.url;
  //       selectedUser = this.gos.find(user => user.id === selectedUserId);
  //       // if (selectedUser) {
  //       //   this.gosList.push(selectedUser);
  //       // }
  //     } else {
  //       const numberOfUsersToSelect = 5;
  //       for (let i = 0; i < numberOfUsersToSelect; i++) {
  //         const rand = Math.random() * cumulativeWeight;
  //         selectedUser = this.gos.find(user => user.cumulativeWeight >= rand);
  //         // if (selectedUser) {
  //         //   this.gosList.push(selectedUser);
  //         // }
  //       }
  //     }
  //     if (selectedUser) {
  //       this.gosList.push(selectedUser);
  //       console.log('#',selectedUser)
  //     }

  //     this.$nextTick(this.initializeIntersectionObserver);
  //   } catch (error) {
  //     console.error('Error fetching initial user data:', error);
  //   }
  // },

    initializeIntersectionObserver() {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const userIndex = entry.target.getAttribute('data-user-index');
          const userId = entry.target.getAttribute('data-user-id');
          this.lastPos = userIndex;
          if (!this.loadedProfiles.includes(userId)) {
            this.fetchUserProfile(userId);
            this.loadedProfiles.push(userId);
          } else {
            const firstIndex = this.gosList.findIndex(user => user.id === userId);
            if (firstIndex !== -1 && userIndex !== -1) {
              this.$set(this.gosList, userIndex, this.gosList[firstIndex]);
            }
          }
          const isLastItem = Number(this.gosList.length - 1) === Number(userIndex);
          if (isLastItem) {
            this.loadMoreProfiles();
          }
        });
      }, { root: null, threshold: 0.1 });
      this.$nextTick(() => {
        document.querySelectorAll('.user-div').forEach(userDiv => {
          this.observer.observe(userDiv);
        });
      });
    },
    async fetchUserProfile(uid) {
      try {
        if (!uid) return;
        const index = this.gosList.findIndex(user => user.id === uid);
        if (index === -1) return;
        console.log('fetching user profile for', uid)
        const userProfileSnapshot = await db.ref(`/users/${uid}`).once('value');
        const userProfile = userProfileSnapshot.val();
        if (!userProfile) {
          console.warn(`User profile for UID ${uid} not found.`);
          return;
        }
        if (userProfile.account === 7 && !this.gosList[index].p) {
          await db.ref(`/${this.path}/${uid}/p`).transaction(() => true);
        }
        if (userProfile.categories && Object.values(userProfile.categories).includes('fancentro') && !this.gosList[index].f) {
          await db.ref(`/${this.path}/${uid}/f`).transaction(() => true);
        }
        this.$set(this.gosList, index, { ...this.gosList[index], ...userProfile });
      } catch (error) {
        console.error('Error fetching user profile:', error);
      }
    },
  },
}
</script>


<style>
/* @import url('https://fonts.googleapis.com/css2?family=Allura&display=swap'); */
@import url('https://fonts.googleapis.com/css2?6family=Josefin+Sans:wght@700&display=swap');


html, body, #app{ 
  height: 100%;
  margin: 0;
  overflow: hidden;
}
/* 
 */
 .fcProfile{
  background-color: #3F3456;
 }
.gos{
  height: 100%;
  display: flex;
  flex-flow: column;
  /* padding:10px; */
  /* border-radius:10px; */
  /* overflow: hidden; */
}
.gos .content{
  /* aspect-ratio:9/16; */
  /* height: calc(100% - 100px); */
  height: 100%;
  flex: 1;
  position: relative;
  overflow: scroll;
  scroll-snap-type: y mandatory;
  
}

.gos .content .actionBar{
  padding:10px 20px;
  color: #ffffff;
  /* top:0; */
  right:0;
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 10px;
  display: flex;
  /* flex-flow: column; */
  align-items: end;
  justify-content:space-between;
  width:100%;
  font-size:x-large;
}

.actionBar .name{
  text-transform: uppercase;
  font-weight: bold;
  filter: drop-shadow(rgb(34, 34, 34) 2px 2px 4px);
}

.md-icon-button{
  filter: drop-shadow(rgb(34, 34, 34) 2px 2px 4px);
}

.actionBar .url{
  margin-top:10px;
  line-height: normal;
  font-size:small;
  filter: drop-shadow(rgb(34, 34, 34) 2px 2px 4px);
}
.section{
  height: 100%;
  scroll-snap-align: start;
  scroll-snap-stop: always;
  scroll-behavior: smooth;
  position: relative;
}
.md-boards{
  max-height:calc(100% - 100px)
  
}

.md-boards .md-boards-content{
  height:100% !important;
}

.md-boards .md-board{
  /* border:1px solid darkblue; */
  padding: 0;
  height:100%;  
}

.displayImageContainer{
  width:100%;
  height:100% !important;
  max-height:calc(100% - (100vw / 300 * 100));
  position:relative;
  /* object-fit: cover; */
  /* aspect-ratio: 428/830; */
}

.displayImage{
  width:100%;
  height:100% !important;
  /* max-height:calc(100% - (100vw / 300 * 100)); */
  object-fit: cover;
  /* aspect-ratio: 428/830; */
}

.md-boards .md-boards-navigation{
  position:absolute;
}

.md-theme-default.md-boards>.md-boards-navigation .md-board-header.md-active{
  color:#ffffff;
}

.md-avatar{
  border:2px solid #ffffff;
  margin:unset;
}

.fancentro{
  color: #3F3456 !important;
  font-weight: bolder;;
}

.md-avatar img{
  object-fit:cover;
}

.gos .header{
  user-select: none;
  filter: drop-shadow(rgb(34, 34, 34) 2px 2px 4px);
  line-height: normal;
    /* font-family: 'Allura', cursive; */
    font-family: 'Josefin Sans', sans-serif;
    /* text-transform: uppercase; */
    /* border: 2px solid white; */
    position: absolute;
    color: #ffffff;
    z-index: 1;
    width: 100%;
    text-align: center;
    /* padding: 20px 10px; */
    font-size: x-large;
    font-weight: bold;
    position: sticky;
    background: #000000;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
}
.gosHeader{
  color:#EF718E;
}

.bosHeader{
  color:skyblue;
}
.gos .header img{
  padding:5px;
}
</style>
<style scoped>
.ad{
  /* background: lightskyblue; */
  /* border:1px solid darkgreen; */
  /* height:100px; */
  aspect-ratio:300/100;
  max-height:200px;
  width:100vw;
  position: relative;
  bottom: 0;
  display: flex;
  justify-content: center;
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/gos.vue